export var DividerSize;

(function (DividerSize) {
  DividerSize["X_SMALL"] = "xSmall";
  DividerSize["SMALL"] = "small";
})(DividerSize || (DividerSize = {}));

export var DividerOrientation;

(function (DividerOrientation) {
  DividerOrientation["VERTICAL"] = "vertical";
  DividerOrientation["HORIZONTAL"] = "horizontal";
})(DividerOrientation || (DividerOrientation = {}));